// extracted by mini-css-extract-plugin
module.exports = {"container":"TabBar_container__abv_q","tab":"TabBar_tab__pJdqT","active":"TabBar_active__cVsLL"};